export const constantName = 'OAuth2AuthorizationProxyDemoAppConfiguration';

export default {
    facebookAppId: '216750812448511',
    googleClientId: '692293897979-f8l8e01f513evte972148bhc73jbnl2v.apps.googleusercontent.com'
};
